// document.addEventListener('DOMContentLoaded', function() {
//   const popupWrap = document.querySelector('.promo-popup-wrap');
//   const popupTimeout = parseInt(popupWrap.getAttribute('data-popup-timeout'), 10) * 1000;
//   const popupTimes = parseInt(popupWrap.getAttribute('data-popup-times'), 10);
// 	const successMessage = popupWrap.querySelector('.promo-popup-success');
//   const closeButtons = popupWrap.querySelectorAll('.promo-popup-close');
//   const overlay = popupWrap.querySelector('.overlay');
//   const form = popupWrap.querySelector('form');

//   let popupCounter = sessionStorage.getItem('popupCounter') || 0;
//   let formSubmitted = localStorage.getItem('formSubmitted') === 'true';
//   const successMessageIsShown = localStorage.getItem('successMessageIsShown') === 'true';

// 	if (formSubmitted && successMessage && !successMessageIsShown) {
//     openPopup();
//     localStorage.setItem('successMessageIsShown', 'true');
// 	}

//   function openPopup() {
//     popupWrap.style.visibility = 'visible';
//     popupWrap.style.opacity = '1';
//     popupCounter++;
//     sessionStorage.setItem('popupCounter', popupCounter);
//   }

//   function closePopup() {
//     popupWrap.style.visibility = 'hidden';
//     popupWrap.style.opacity = '0';
//   }

//   if (!formSubmitted && popupCounter < popupTimes) {
//     setTimeout(openPopup, popupTimeout);
//   }

// 	if (closeButtons.length) {
// 		closeButtons.forEach( btn => {
// 			btn.addEventListener('click', function() {
//         closePopup();
//       });

// 			btn.addEventListener('keydown', function(event) {
// 				if (event.key === 'Enter' || event.key === ' ') {
// 					closePopup();
// 				}
// 			});
// 		})
// 	}

//   overlay.addEventListener('click', function() {
//     closePopup();
//   });

//   form.addEventListener('submit', function() {
//     localStorage.setItem('formSubmitted', 'true');
//     localStorage.setItem('successMessageIsShown', 'false');
//   });

// 	const addCopyBtn = () => {
// 		const copyBtn = document.querySelector('.promo-popup-discount__copy-btn');
// 		if (!copyBtn) {
// 			return;		
// 		}

// 		const { id } = copyBtn.dataset;
// 		if (!id) {
// 			return;
// 		}

// 		const textElement = document.getElementById(`${id}`);
// 		if (!textElement) {
// 			return;	
// 		}
		
// 		const textToCopy = textElement.innerText;
// 		let timeoutId;
		
// 		copyBtn.addEventListener('click', () => {
// 			if (navigator.clipboard && navigator.clipboard.writeText) {
// 				navigator.clipboard.writeText(textToCopy).then(function () {
// 					copyBtn.classList.add('js-copied');

// 					if (timeoutId) {
// 						clearTimeout(timeoutId);
// 					}

// 					timeoutId = setTimeout(() => {
// 						copyBtn.classList.remove('js-copied');
// 						timeoutId = null; 
// 					}, 3000);
// 				})
// 			}
// 		});
// 	}

// 	addCopyBtn();
// });

document.addEventListener('DOMContentLoaded', function() {
	const popupWrap = document.querySelector('.promo-popup-wrap');
	if (!popupWrap) return;
	
	const popupTimeout = parseInt(popupWrap.getAttribute('data-popup-timeout'), 10) * 1000;
	const popupTimes = parseInt(popupWrap.getAttribute('data-popup-times'), 10);
	const successMessage = popupWrap.querySelector('.promo-popup-success');
	const closeButtons = popupWrap.querySelectorAll('.promo-popup-close');
	const overlay = popupWrap.querySelector('.overlay');
	const form = popupWrap.querySelector('form');

	// ───────── 新增：底部重新打开按钮 ─────────
	const reopenBtn   = document.getElementById('promoReopenBtn');
  	const reopenClose = document.querySelector('.promo-reopen-close');

	let popupCounter = parseInt(sessionStorage.getItem('popupCounter') || 0, 10);
	let formSubmitted = localStorage.getItem('formSubmitted') === 'true';
	const successMessageIsShown = localStorage.getItem('successMessageIsShown') === 'true';
	const manuallyClosed = sessionStorage.getItem('promoReopenManuallyClosed') === 'true';
	
	if (formSubmitted && successMessage && !successMessageIsShown) {
	  openPopup();
	  localStorage.setItem('successMessageIsShown', 'true');
	}

	// openPopup();

	// Function to decide if reopen button should show
	function updateReopenButtonVisibility() {
		if (!reopenBtn) return;

		// Show reopen button if:
		// - Popup was ever opened and closed
		// - Not manually closed this session
		// - And (optional) popupCounter > 0 or formSubmitted
		if (popupCounter > 0 && !manuallyClosed) {
		reopenBtn.style.display = 'flex';
		} else {
		reopenBtn.style.display = 'none';
		}
	}

	// Initial check on every page load
  	updateReopenButtonVisibility();

	function showReopenButton() {
		if (reopenBtn) {
		reopenBtn.style.display = 'flex';
		}
	}

	function hideReopenButton() {
		if (reopenBtn) {
		reopenBtn.style.display = 'none';
		}
	}

	// 点击底部按钮 → 打开弹窗
	if (reopenBtn) {
		reopenBtn.addEventListener('click', function (e) {
		// 防止点关闭按钮时也触发打开
		if (e.target.closest('.promo-reopen-close')) return;
			openPopup();
		});
	}

	// 点击底部 × → 彻底隐藏按钮（本次会话不再显示）
	if (reopenClose) {
		reopenClose.addEventListener('click', function (e) {
		e.stopPropagation();
		hideReopenButton();
		// 可选：记录已手动关闭，避免刷新后又出现
		sessionStorage.setItem('promoReopenManuallyClosed', 'true');
		});
	}
	
	function openPopup() {
		popupWrap.style.visibility = 'visible';
		popupWrap.style.opacity = '1';

		// 修复遮罩问题
		overlay.classList.remove('hidden');
		
	  	sessionStorage.setItem('popupCounter', ++popupCounter);
	}
	
	function closePopup() {
	  	popupWrap.style.visibility = 'hidden';
	  	popupWrap.style.opacity = '0';
		overlay.classList.add('hidden');

	  	// 关闭弹窗 → 显示底部按钮（除非用户已经手动关掉过）
		// const manuallyClosed = sessionStorage.getItem('promoReopenManuallyClosed') === 'true';
		if (!manuallyClosed) {
			showReopenButton();
		}
	}
	
	if (!formSubmitted && popupCounter < popupTimes) {
	  setTimeout(openPopup, popupTimeout);
	}
	
	if (closeButtons.length) {
	  closeButtons.forEach(btn => {
		btn.addEventListener('click', closePopup);
		
		btn.addEventListener('keydown', function(event) {
		  if (event.key === 'Enter' || event.key === ' ') {
			closePopup();
		  }
		});
	  });
	}
	
	if (overlay) {
	  overlay.addEventListener('click', closePopup);
	}
	
	if (form) {
	  form.addEventListener('submit', function() {
		localStorage.setItem('formSubmitted', 'true');
		localStorage.setItem('successMessageIsShown', 'false');
	  });
	}
	
	function addCopyBtn() {
	  const copyBtn = document.querySelector('.promo-popup-discount__copy-btn');
	  if (!copyBtn) return;
	  
	  const { id } = copyBtn.dataset;
	  if (!id) return;
	  
	  const textElement = document.getElementById(`${id}`);
	  if (!textElement) return;
	  
	  const textToCopy = textElement.innerText;
	  let timeoutId;
	  
	  copyBtn.addEventListener('click', () => {
		if (navigator.clipboard && navigator.clipboard.writeText) {
		  navigator.clipboard.writeText(textToCopy).then(function () {
			copyBtn.classList.add('js-copied');
			
			if (timeoutId) clearTimeout(timeoutId);
			
			timeoutId = setTimeout(() => {
			  copyBtn.classList.remove('js-copied');
			  timeoutId = null;
			}, 3000);
		  });
		}
	  });
	}
	
	addCopyBtn();
  });
  